import ReactComponent from '../app/ReactComponent'

import {
  AP_AGREEMEMT_TYPE_ID, AP_REFERENCE_OTHER_OPTION_ID
} from '../helpers/misc'
import {
  PROPERTY_AP_REFERENCE_KEY, PROPERTY_AP_OTHER_REFERENCE_KEY
} from '../helpers/properties'

import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Layout,
  Radio,
  Result, Row,
  Select, Space,
  Spin, Switch
} from 'antd'
import {Link, useNavigate} from 'react-router-dom'
import {CaretDownOutlined, CloseOutlined, LeftOutlined} from '@ant-design/icons'
import dayjs from 'dayjs'
import React, {createRef} from 'react'
import {parsePhoneNumber} from 'awesome-phonenumber'
import {getAddressTypeNameByAddressTypeId} from '../services/addresses'
import {fixZIP} from '../helpers/utils'
import App from '../app/App'
import {MarketingCommunicationModal} from '../components/form/MarketingCommunicationModal'
import {BANK_CODE} from '../services/bank_code'

export class ProfileUpdatePage extends ReactComponent {
  accountFormRef = createRef()

  state = {
    loading_page: false,
    constants: {
      AP_AGREEMEMT_TYPE_ID
    },
    account: {},
    account_properties: {},
    bank_account_countries: [],
    bank_code: BANK_CODE,
    bookings: [],
    arrived_alert: false,
    agreement_label: 'Souhlas se zpracováním osobních údajů',
    agreement_text: false,
    agreement_marketing_communication: null,
    max_date: dayjs().subtract(18, 'year'),
    references: [],
    reference_detail: false
  }

  async componentDidMount() {

    this.scrollToTop()

    this.pushPageAnalytics('Můj profil - Moje Amber')

    void this.updateState({loading_page: true})

    void this.getDataForForm()

  }

  async getDataForForm() {
    const countries = await this.$app.$store('common').getCountries()
    const languages = await this.$app.$store('common').getLanguages()
    const address_types = await this.$app.$store('account').getAddressTypes()
    const addresses = await this.$app.$store('account').getAddresses()
    const account = await this.$app.$store('account').getPersonalInfo()
    const bank_account_countries = await this.$app.$store('common').getBankAccountCountries()

    if(!account.birthdate)
      await this.loadReferences()

    const account_properties = await this.$app.$store('account').getProperties()

    const {bookings: arrived_bookings = []} = await this.$api({
      action: 'carecloud_api',
      route: `bookings?booking_statuses[]=${this.state.constants.AP_BOOKING_STATUS_ARRIVED_ID}`
    })

    const {name: agreement_label = false, text: agreement_text = false} = await this.$api({
      action: 'carecloud_api',
      route: `agreements/${this.state.constants.AP_AGREEMEMT_TYPE_ID}`
    })

    await this.updateState({
      loading_page: false,
      account,
      account_properties,
      bank_account_countries,
      countries: countries,
      languages: languages,
      address_types: address_types,
      addresses: addresses,
      arrived_alert: !!arrived_bookings.length,
      agreement_label: (agreement_label ?? this.state.agreement_label),
      agreement_text: (agreement_text ?? this.state.agreement_text),
      agreement_marketing_communication: account.agreement_mc
    })

    this.valuesForFormItems()

  }

  valuesForFormItems() {

    this.accountFormRef.current.setFieldValue('pre_nominals', this.state.account.pre_nominals)
    this.accountFormRef.current.setFieldValue('first_name', this.state.account.first_name)
    this.accountFormRef.current.setFieldValue('last_name', this.state.account.last_name)

    if (this.state.account.gender) {
      this.accountFormRef.current.setFieldValue('gender', parseInt(this.state.account.gender))
    }

    this.accountFormRef.current.setFieldValue('email', this.state.account.email)

    if (this.state.account.phone) {
      const phoneNumber = parsePhoneNumber('+' + this.state.account.phone)
      if (phoneNumber.valid) {
        this.accountFormRef.current.setFieldValue('phone', phoneNumber.number.national)
        this.accountFormRef.current.setFieldValue('phone_prefix', '+' + phoneNumber.countryCode)
      }
    } else {
      this.accountFormRef.current.setFieldValue('phone_prefix', '+420')
    }

    if (this.state.account.birthdate) {
      this.accountFormRef.current.setFieldValue('birthdate', dayjs(this.state.account.birthdate))
    }

    this.accountFormRef.current.setFieldValue('city', this.state.account.city)
    this.accountFormRef.current.setFieldValue('descnumber', this.state.account.descnumber)
    this.accountFormRef.current.setFieldValue('street', this.state.account.street)
    this.accountFormRef.current.setFieldValue('zip', this.state.account.zip)
    this.accountFormRef.current.setFieldValue('orientnumber', this.state.account.orientnumber)
    this.accountFormRef.current.setFieldValue('agreement_marketing_communication', !this.state.agreement_marketing_communication)

    // TODO: NEXT LINE CHOOSE SELECTED WHEN EXISTS
    const {property_value: bank_account = ''} = this.state.account_properties.find(item => item.property_id === 'bank_account_number') ?? {}

    if(bank_account) {
      this.accountFormRef.current.setFieldValue('bank_account_number', bank_account.split('/')[0])
      this.accountFormRef.current.setFieldValue('bank_account_code', bank_account.split('/')[1])
    }

  }

  async sendFormData(data) {

    void this.updateState({loading_page: true})

    let saved = false

    try {

      //const agreement_gtc = (+ this.state.agreement_gtc)
      const agreement_marketing_communication = +(this.state.agreement_marketing_communication)
      const phone = (data.phone_prefix + data.phone).replace(/\s/g, '')

      if(!data.email || !data.phone) throw 'Položky označené * jsou povinné.'
      //if(!agreement_gtc) throw 'Souhlas se zpracováním osobních údajů je povinný.'

      let property_records = []

      const bank_account = this.validateBankAccount(data.bank_account_number, data.bank_account_code)
      const savedBankAccount = this.state.account_properties.find(item => item.property_id === 'bank_account_number')
      const hasSavedBankAccount = savedBankAccount && savedBankAccount.property_value

      if(bank_account && this.state.bank_account_countries.length > 0)
        property_records.push({
          property_id: 'bank_account_country',
          property_value: [{id: this.state.bank_account_countries[0].id}]
        }, {
          property_id: 'bank_account_number',
          property_value: bank_account
        })
      else if(!bank_account && hasSavedBankAccount) {
        await this.$api({
          action: 'carecloud_user_api',
          method: 'DELETE',
          route: `property-records/bank_account_number`
        })

        this.accountFormRef.current.setFieldValue('bank_account_code', undefined)
      }

      await this.$api({
        action: 'carecloud_user_api',
        method: 'PUT',
        data: {
          customer: {
            personal_information: {
              pre_nominals: data.pre_nominals,
              first_name: data.first_name,
              last_name: data.last_name,
              gender: data.gender || this.state.account.gender,
              birthdate: data.birthdate ? dayjs(data.birthdate).format('YYYY-MM-DD') : this.state.account.birthdate,
              email: data.email,
              phone: phone,
              address: {
                address1: data.street,
                address2: data.descnumber,
                address3: data.orientnumber,
                city: data.city,
                zip: fixZIP(data.zip),
                country_code: this.state.account.country_code
              },
              agreement: {
                agreement_marketing_communication: agreement_marketing_communication
              },
              language_id: this.state.account.language_id
            }
          },
          property_records
        }
      })

      if(!this.state.account.birthdate && data.reference)
        await this.saveEnumProperty(PROPERTY_AP_REFERENCE_KEY, data.reference)

      if(!this.state.account.birthdate && data.other_reference)
        await this.saveProperty(PROPERTY_AP_OTHER_REFERENCE_KEY, data.other_reference)

      // refresh data

      const account = await this.$app.$store('account').getPersonalInfo(true)
      const account_properties = await this.$app.$store('account').getProperties()

      await this.updateState({
        account: account,
        account_properties: account_properties,
      })

      App.$toast('Údaje byly aktualizovány.')
      //this.$toast.success(this.$t('notices.successfully_updated'))

      saved = true

    } catch (error) {

      //console.log(error)
      this.handleError(error)

    } finally {

      void this.updateState({loading_page: false})

    }

    if(saved)
      this.props.navigate('/')

  }

  async sendAddressData(data, id) {

    void this.updateState({loading_page: true})

    try {

      //const data = serializeObject(this.$refs[id][0].$el)

      await this.$api({
        action: 'carecloud_user_api',
        route: `addresses/${id}`,
        method: 'PUT',
        data: {
          additional_address: {
            address_type: data.address_type,
            address: {
              address1: data.street,
              address2: data.descnumber,
              address3: data.orientnumber,
              city: data.city,
              zip: fixZIP(data.zip),
              country_code: 'cz'
            }
          }
        }
      })

      // refresh addresses
      //await this.getAddresses()

      //this.$toast.success(this.$t('notices.successfully_updated'))

    } catch (error) {

      console.log(error)

    } finally {

      void this.updateState({loading_page: false})

    }

  }

  async loadReferences() {

    const {items: references = []} = await this.$api({
      action: 'carecloud_api',
      route: `customer-properties/${PROPERTY_AP_REFERENCE_KEY}`
    })

    await this.updateState({references})

  }

  async saveProperty(property_id, property_value) {

    return this.$api({
      action: 'carecloud_user_api',
      method: 'PUT',
      route: `property-records/${property_id}`,
      data: {
        property_record: {
          property_id,
          property_value
        }
      }
    })

  }

  async saveEnumProperty(property_id, property_value) {

    return this.saveProperty(property_id, [{ id: property_value }])

  }

  getAddressTypeName(id) {

    return getAddressTypeNameByAddressTypeId(this.address_types, id, this.$tc('common.unknown', 2))

  }

  validateBankAccount(bank_account_number, bank_account_code) {
    const accountNumber = bank_account_number ? String(bank_account_number).trim() : ''
    const accountCode = bank_account_code ? String(bank_account_code).trim() : ''

    // Pokud není vyplněné číslo účtu, vrátíme null (DELETE se provede)
    if(!accountNumber)
      return null

    const mainAccount = accountNumber.includes('-')
      ? accountNumber.split('-')[1]
      : accountNumber

    // Kontrola formátu čísla účtu - může obsahovat číslice a pomlčku pro předčíslí (např. 19-123456789)
    if(!/^(\d+-)?(\d+)$/.test(accountNumber))
      throw 'Neplatný formát čísla účtu.'

    if(mainAccount.length > 10)
      throw 'Číslo účtu může mít maximálně 10 číslic.'

    if(accountNumber.includes('-')) {

      const prefix = accountNumber.split('-')[0]

      if(prefix.length > 6)
        throw 'Předčíslí může mít maximálně 6 číslic.'

    }

    // Kontrola zda kód banky obsahuje pouze číslice a má délku 4
    if(!/^\d{4}$/.test(accountCode))
      throw 'Kód banky neodpovídá. Musí mít 4 číslice.'

    // Vrácení formátovaného čísla účtu
    return `${accountNumber}/${accountCode}`
  }

  render() {
    return (
      <Layout tagName="main" className="page-with-title">
        <Row align="center mb-4">
          <Col xs={24} md={24} xl={20}>
            <Space className="title-with-btn" size={[0, 0]}>
              <a onClick={() => {
                this.backToHistory()
              }}><LeftOutlined/><span className="back-to-btn">Zpět</span></a>
              <h1 className="mb-0">Moje údaje</h1>
            </Space>
          </Col>
        </Row>
        <Row align="center" className="margin-auto">
          <Col xs={23}>
            <Spin spinning={this.state.loading_page} size="large">
              <Card bordered={false} style={{maxWidth: 680}} className="card register">
                {this.state.complete && <Result
                  status="success"
                  title="Registrace byla úspěšná."
                  subTitle="Odkaz pro nastavení hesla Vám přijde na e-mail."/>
                }
                {!this.state.ongoing_alert &&
                  !this.state.blocked_alert &&
                  !this.state.complete &&
                  <Form
                    ref={this.accountFormRef}
                    layout="horizontal"
                    labelCol={{span: 7}}
                    wrapperCol={{span: 17}}
                    onFinish={(...args) => this.sendFormData(...args)}>

                    <div className="form-container">
                      <Form.Item
                        label="Titul"
                        name="pre_nominals"
                      >
                        <Input placeholder="Zadejte titul" size="large"/>
                      </Form.Item>
                      <Form.Item
                        label="Jméno"
                        name="first_name"
                        rules={[{
                          required: true,
                          message: 'Prosím vyplňte Jméno'
                        }]}
                        className={this.className(["required", !!this.state.account.birthdate && "disabled"])}
                      >
                        <Input placeholder="Zadejte jméno" size="large" disabled={!!this.state.account.birthdate}/>
                      </Form.Item>

                      <Form.Item
                        label="Přijmení"
                        name="last_name"
                        rules={[{
                          required: true,
                          message: 'Prosím vyplňte Příjmení'
                        }]}
                        className={this.className(["required", !!this.state.account.birthdate && "disabled"])}
                      >
                        <Input placeholder="Zadejte příjmení" size="large" disabled={!!this.state.account.birthdate}/>
                      </Form.Item>

                      <Form.Item
                        label="Pohlaví"
                        name="gender"
                        className={this.className(["flex-start", !!this.state.account.birthdate ? "disabled" : "required"])}>
                        <Radio.Group disabled={!!this.state.account.birthdate}>
                          <Radio value={1}>Muž</Radio>
                          <Radio value={2}>Žena</Radio>
                        </Radio.Group>
                      </Form.Item>

                      <Form.Item
                        label="E-mail"
                        name="email"
                        rules={[{
                          required: true,
                          message: 'Prosím vyplňte E-mail'
                        }]}>
                        <Input placeholder="Zadejte váš email" size="large"/>
                      </Form.Item>

                      <Form.Item
                        label="Telefonní číslo"
                        name="phone"
                        rules={[{
                          required: true,
                          message: 'Prosím vyplňte Telefonní číslo'
                        }]}>

                        <Input placeholder="Zadejte vaše tel. číslo"
                               addonBefore={<Form.Item name="phone_prefix" initialValue="420" noStyle>
                                 <Select
                                   suffixIcon={<CaretDownOutlined className="ant-select-suffix"/>}
                                   style={{
                                     width: 85
                                   }}
                                 >
                                   <Select.Option value="420" selected>+420</Select.Option>
                                   <Select.Option value="421">+421</Select.Option>
                                   <Select.Option value="380">+380</Select.Option>
                                 </Select>
                               </Form.Item>}
                               style={{
                                 width: '100%'
                               }}
                        />
                      </Form.Item>

                      <Form.Item
                        label="Datum narození"
                        name="birthdate"
                        className="datepicker"
                        rules={[{
                          required: true,
                          message: 'Prosím vložte Datum narození'
                        }]}>
                        <DatePicker
                          placeholder="    .    ."
                          format="DD.MM.YYYY"
                          inputReadOnly={('ontouchstart' in document.documentElement)}
                          disabledDate={current => (current > dayjs(this.state.max_date))}
                          defaultPickerValue={dayjs(this.state.max_date)}
                          size="large"
                          disabled={!!this.state.account.birthdate}/>
                      </Form.Item>

                      {!this.state.account.birthdate &&
                        <Form.Item
                          label="Odkud o nás víte?"
                          name="reference"
                          rules={[{
                            required: true,
                            message: 'Prosím vyplňte Odkud o nás víte'
                          }]}>
                          <Select
                            placeholder="Prosím vyberte"
                            suffixIcon={<CaretDownOutlined className="ant-select-suffix"/>}
                            size="large"
                            onChange={(val) => void this.updateState({reference_detail: val === AP_REFERENCE_OTHER_OPTION_ID})}
                            options={this.state.references.map(item => ({
                              label: item.name,
                              value: item.id
                            }))}/>
                        </Form.Item>
                      }

                      {!this.state.account.birthdate && this.state.reference_detail &&
                        <Form.Item
                          label="Jiné"
                          name="other_reference"
                          rules={[{
                            required: true,
                            message: 'Prosím vyplňte Jiné'
                          }]}>
                          <Input placeholder="Doplňte, odkud o nás víte" size="large"/>
                        </Form.Item>
                      }

                      <Form.Item label="Číslo bankovního účtu" className="contact-descnumber flex-start bank-account">
                        <Space.Compact style={{width: '100%'}}>
                          <Form.Item name="bank_account_number" style={{display: 'inline-block', width: '100%'}}>
                            <Input placeholder="" size="large"/>
                          </Form.Item>
                          <span className="separator">/</span>
                          <Form.Item name="bank_account_code" style={{display: 'inline-block', width: 100}}>
                            <Select
                              placeholder="Kód banky"
                              suffixIcon={<CaretDownOutlined className="ant-select-suffix"/>}
                              style={{
                                width: 100
                              }}
                              options={this.state.bank_code.map(item => ({
                                label: item.id,
                                value: item.id
                              }))}
                            />
                          </Form.Item>
                        </Space.Compact>
                      </Form.Item>

                    </div>

                    <h4>Doplňující údaje</h4>

                    <div className="form-container">

                      <Form.Item label="Ulice" name="street" className="GoogleAutocompleteAddressTrigger">
                        <Input placeholder="Zadejte část adresy" size="large"/>
                      </Form.Item>

                      <Form.Item label="Číslo popisné / orientační" className="contact-descnumber flex-start">
                        <Form.Item name="descnumber" style={{display: 'inline-block', width: 100}}>
                          <Input placeholder="" size="large"/>
                        </Form.Item>
                        <span style={{margin: 'auto 5px'}}>/</span>
                        <Form.Item name="orientnumber" style={{display: 'inline-block', width: 100}}>
                          <Input placeholder="" size="large"/>
                        </Form.Item>
                      </Form.Item>

                      <Form.Item label="PSČ" name="zip" className="flex-start">
                        <Input placeholder="" size="large" style={{width: 100}}/>
                      </Form.Item>

                      <Form.Item label="Město" name="city">
                        <Input placeholder="" size="large"/>
                      </Form.Item>

                      <Form.Item className="consent">
                        <Form.Item
                          name="agreement_marketing_communication"
                          className="switch-container"
                        >
                          <Switch
                            id="agreement_marketing_communication"
                            checked={!this.state.agreement_marketing_communication}
                            style={{marginRight: '0.9em'}}
                            onChange={(data) => {
                              void this.updateState({agreement_marketing_communication: !data})
                            }}/>
                        </Form.Item>
                        <label htmlFor="agreement_marketing_communication" className="required">Nesouhlasím s marketingovou komunikací (zasíláním obchodních sdělení) <MarketingCommunicationModal/></label>
                      </Form.Item>
                    </div>

                    <Space style={{marginTop: '30px'}} size={[12, 10]} className="btn-container">
                      <Link to="/">
                        <Button type="text" className="btn-cancel" icon={<CloseOutlined/>}>Zrušit změny</Button>
                      </Link>
                      <Button htmlType="submit" type="primary" className="btn btn-secondary"
                              icon={<Spin spinning={this.state.loading_page}/>}
                              style={{minWidth: 152, width: 152}}>Uložit</Button>
                    </Space>

                  </Form>
                }
              </Card>
            </Spin>
          </Col>
        </Row>

      </Layout>
    )
  }
}

export function ProfileUpdatePageHOC() {
  const navigate = useNavigate()

  return <ProfileUpdatePage navigate={navigate}/>
}